export default {
    list: [
        'up-to-50',
        'encrypted-calls-EU',
        'sharescreen"',
        'invitation-SMS-email-notifs',
        'group-contact',
        'reminder-SMS-email',
        'API-instantvisio',
    ],
}
